export default "__VITE_ASSET__CLALDzXW__"